import { forwardRef, useEffect, useState } from "react";
import axios from "axios";

import { Box, Button, Dialog, Divider, Slide, Stack } from "@mui/material";

import {
	styleFabricAssociation,
	styleTrimsAssociation,
	fabricTableColumns,
	pimDescCatAssociationObj,
	trimsTableColumns,
	styleValueAddAssocition,
	valueAddTableColumns,
} from "../data";
import { attrGroupLinkedTables, styleImagesAssocObj, productionStageOptions, styleFileAssocObj } from "components/PimDashboard/data";
import { getRelProtectedFileSignedUrl, inputTypes, muiCustomScrollbar } from "data/globalData";

import { AuthState } from "context/AuthContext";
import { PimDashboardState } from "context/PimDashboardContext";
import { GlobalState } from "context/GlobalContext";

import FabricTable from "./FabricTable/FabricTable";
import TrimsTable from "./TrimsTable/TrimsTable";
import StyleDetailsGrid from "components/ReusableComponents/StyleDetailsGrid/StyleDetailsGrid";
import ValueAdditionTable from "./ValueAdditionTable/ValueAdditionTable";
import { grey, yellow } from "@mui/material/colors";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import moment from "moment";
import { fileColumn } from "components/PimDashboard/CommonComponents/AddFiles/AddFiles";
import { fileTypes } from "../../CreateStyle/data";

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const FullScreenPopup = ({ modal, setModal, selectedStyle, styleStaticData, allStyles, setAllStyles }) => {
	const { snackBar, setSnackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const { setSelectedStyle, allAttributes, commodityCatMaster, setCommodityCatMaster } = PimDashboardState();
	const { user } = AuthState();
	const [updatedFabricArr, setUpdatedFabricArr] = useState([]);
	const [updatedValueAddArr, setUpdatedValueAddArr] = useState([]);
	const [updatedTrimsArr, setUpdatedTrimsArr] = useState([]);

	useEffect(() => {
		const fetch = async () => {
			try {
				const res = await axios.get("/api/master/get_commodity_cat_master?categories=A,V");
				setCommodityCatMaster(res.data?.result);
			} catch (error) {
				console.log(error);
				setSnackBarOpen(true);
				setLoadingOpen(false);
				setSnackBar({
					...snackBar,
					message: parseErrorMessage(error),
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			}
		};
		if (!commodityCatMaster && commodityCatMaster?.length !== 0) fetch();
	}, [commodityCatMaster]);
	// const [deleteFabricArr, setDeleteFabricArr] = useState([]);
	// const [deleteTrimsArr, setDeleteTrimsArr] = useState([]);

	const [saveDisabled, setSaveDisabled] = useState(
		selectedStyle && selectedStyle["stage"] === productionStageOptions.FABRIC_TRIMS.key ? false : true
	);
	const [publishDisabled, setPublishDisabled] = useState(
		selectedStyle && selectedStyle["stage"] === productionStageOptions.FABRIC_TRIMS.key ? false : true
	);
	const [styleFabricArr, setStyleFabricArr] = useState(
		selectedStyle && selectedStyle[styleFabricAssociation] ? selectedStyle[styleFabricAssociation] : []
	);
	const [styleValueAddArr, setStyleValueAddArr] = useState(
		selectedStyle && selectedStyle[styleValueAddAssocition] ? selectedStyle[styleValueAddAssocition] : []
	);
	const [styleTrimsArr, setStyleTrimsArr] = useState(
		selectedStyle && selectedStyle[styleTrimsAssociation] ? selectedStyle[styleTrimsAssociation] : []
	);

	const handleCloseModal = () => {
		setModal(false);
		setUpdatedFabricArr();
		setUpdatedTrimsArr();
		setUpdatedValueAddArr();
		setSelectedStyle();
		setLoadingOpen(false);
	};
	const handlePublishClick = async () => {
		const run = await handleSaveClick(false);

		try {
			if (
				run ||
				(selectedStyle &&
					selectedStyle[styleFabricAssociation]?.length &&
					selectedStyle[styleTrimsAssociation]?.length &&
					selectedStyle[styleValueAddAssocition]?.length)
			) {
				let body = {
					stage: productionStageOptions?.BUYING.key,
					fabric_trims_published_by: user?.email,
					fabric_trims_published_date: moment().format("YYYY-MM-DD"),
				};
				await axios.post(`/api/fabric_trims/publish?styleId=${selectedStyle?.style_id}`, body).then((res) => {
					setAllStyles(
						allStyles?.map((row) => {
							if (row?.style_id === styleStaticData?.style_id) return { ...row, ...body };
							else return row;
						})
					);
					handleCloseModal();
				});
			} else {
				throw new Error("Fill data in all three tables");
			}
		} catch (error) {
			// console.log(error);
			setSnackBarOpen(true);
			setLoadingOpen(false);
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};
	const handleSaveClick = async (modalClose) => {
		setLoadingOpen(true);
		if (!updatedFabricArr?.length && !updatedTrimsArr?.length && !updatedValueAddArr?.length && modalClose) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "No Changes To Save",
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return false;
		}
		const emptyFieldsFabric = updatedFabricArr?.reduce((acc, fabricObj) => {
			let obj = {};
			Object.keys(fabricTableColumns).forEach((row) => {
				if (fabricObj[row] === inputTypes.SELECT.key) {
					obj[row] = fabricObj[row];
				}
			});
			if (Object.keys(obj)?.length) acc.push(obj);

			return acc;
		}, []);
		console.log(emptyFieldsFabric, "emptyFieldsFabric");
		// form conditions
		const emptyFieldsTrims = updatedTrimsArr?.reduce((acc, trimsObj) => {
			let obj = {};
			Object.keys(trimsTableColumns).forEach((row) => {
				if (trimsObj[row] === inputTypes.SELECT.key) {
					obj[row] = trimsObj[row];
				}
			});
			if (Object.keys(obj)?.length) acc.push(obj);

			return acc;
		}, []);
		const emptyFieldsValueAdd = updatedValueAddArr?.reduce((acc, trimsObj) => {
			let obj = {};
			Object.keys(valueAddTableColumns).forEach((row) => {
				if (trimsObj[row] === inputTypes.SELECT.key) {
					obj[row] = trimsObj[row];
				}
			});
			if (Object.keys(obj)?.length) acc.push(obj);

			return acc;
		}, []);
		if (emptyFieldsFabric?.length || emptyFieldsTrims?.length || emptyFieldsValueAdd?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Fill all the data for ${emptyFieldsFabric?.length ? "FabricTable" : ""} ${
					emptyFieldsTrims?.length ? "Accessories" : ""
				} ${emptyFieldsValueAdd?.length ? "Value Addition" : ""}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			if (modalClose) setLoadingOpen(false);

			return;
		}
		try {
			const res = await axios.post(`/api/fabric_trims/save_fabric_trims_data?styleId=${selectedStyle?.style_id}`, {
				fabricArr: updatedFabricArr,
				trimsArr: updatedTrimsArr,
				valueAddArr: updatedValueAddArr,
			});
			console.log("resad", res.data);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: " Data Saved ",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			// setSelectedStyle({ ...selectedStyle, ...res.data });

			if (modalClose) handleCloseModal();
			// if (typeof submitFunction === "function") submitFunction(res.data);

			return true;
		} catch (error) {
			console.log(error);
			modalClose && setSnackBarOpen(true) && setLoadingOpen(false);
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});

			return false;
		}
	};

	const handleFileDownload = async (row) => {
		{
			try {
				setLoadingOpen(true);
				const fileUrl = await getRelProtectedFileSignedUrl(row?.url);
				if (fileUrl) {
					window.open(fileUrl, "_blank");
					setSnackBarOpen(true);
					setSnackBar({ ...snackBar, message: "File Downloaded Successfully", severity: "success" });
					setLoadingOpen(false);
				}
			} catch (error) {
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: parseErrorMessage(error), severity: "error" });
				setLoadingOpen(false);
			}
		}
	};

	return (
		<Dialog
			fullScreen
			PaperProps={{
				sx: {
					height: "92vh",
					mt: "8vh",
					overflow: "hidden",
				},
			}}
			open={modal}
			onClose={handleCloseModal}
			component="form"
			onSubmit={handlePublishClick}
			TransitionComponent={Transition}>
			<Box width="99%" margin="auto" pt={1} display="flex" columnGap="1%" height="100%" justifyContent="space-between">
				<Stack width="22%">
					<StyleDetailsGrid
						sx={{ width: "100%" }}
						data={styleStaticData}
						groupHeight="29vh"
						files={selectedStyle?.[styleFileAssocObj]?.length ? selectedStyle?.[styleFileAssocObj] : []}
						onFileClick={(row) => handleFileDownload(row)}
					/>
				</Stack>
				<Divider orientation="vertical" />
				<Stack
					width="75%"
					overflow="scroll"
					sx={{ ...muiCustomScrollbar, pb: 6 }}
					pr={1}
					position="relative"
					zIndex={2}
					spacing={1}>
					<Box
						marginLeft="auto"
						display="flex"
						columnGap={1}
						position="fixed"
						top="90%"
						right={10}
						border="1px solid grey"
						boxShadow={4}
						sx={{ background: "white" }}
						p={1}
						borderRadius={1}
						zIndex={100}>
						<Button size="small" variant="outlined" onClick={handleCloseModal} sx={{ ml: "auto" }}>
							Cancel
						</Button>
						<Button size="small" disabled={publishDisabled} variant="contained" onClick={handlePublishClick}>
							Publish
						</Button>
						<Button size="small" disabled={saveDisabled} variant="contained" onClick={() => handleSaveClick(true)}>
							Save
						</Button>
					</Box>
					<FabricTable
						styleFabricArr={styleFabricArr}
						updatedFabricArr={updatedFabricArr}
						setUpdatedFabricArr={setUpdatedFabricArr}
						publishDisabled={publishDisabled}
						// deleteFabricArr={deleteFabricArr}
						// setDeleteFabricArr={setDeleteFabricArr}
					/>
					<TrimsTable
						updatedTrimsArr={updatedTrimsArr}
						setUpdatedTrimsArr={setUpdatedTrimsArr}
						styleTrimsArr={styleTrimsArr}
						// setDeleteTrimsArr={setDeleteTrimsArr}
						// deleteTrimsArr={deleteTrimsArr}
						subArrayKey={pimDescCatAssociationObj}
						publishDisabled={publishDisabled}
						categoryMaster={commodityCatMaster?.filter((row) => row?.commodity_type === "A")}
					/>
					<ValueAdditionTable
						styleValueAddArr={styleValueAddArr}
						updatedValueAddArr={updatedValueAddArr}
						setUpdatedValueAddArr={setUpdatedValueAddArr}
						publishDisabled={publishDisabled}
						categoryMaster={commodityCatMaster?.filter((row) => row?.commodity_type === "V")}
					/>
				</Stack>
			</Box>
		</Dialog>
	);
};

export default FullScreenPopup;
